import { render, staticRenderFns } from "./ItemAdv.vue?vue&type=template&id=feaefe62&scoped=true&lang=pug"
import script from "./ItemAdv.vue?vue&type=script&lang=ts"
export * from "./ItemAdv.vue?vue&type=script&lang=ts"
import style0 from "./ItemAdv.vue?vue&type=style&index=0&id=feaefe62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaefe62",
  null
  
)

export default component.exports